import { useEffect, useState } from 'react'
import { mercure_url } from '../../config/config'
import { useMemo } from 'react'

export function withMercure(WrappedComponent) {
  // eslint-disable-next-line react/display-name
  return (props, state) => {
    const [mercureData, setMercureData] = useState(null)
    const [streamEvent, setStreamEvent] = useState(null)
    const [topics, setTopics] = useState(null)

    useEffect(() => {
      if (!props.subscribeTopics || !mercure_url) {
        return
      }
      const url = new URL(mercure_url)

      let newTopics = ''
      let topic_length = 0
      Object.keys(props.subscribeTopics).map((k) => {
        // eslint-disable-next-line react/prop-types,array-callback-return
        props.subscribeTopics[k].map((v) => {
          if (k && v) {
            const topic = k + '/' + v
            newTopics += topic
            url.searchParams.append('topic', topic)
            topic_length++
          }
        })
      })
      if (!topic_length) return

      if(topics === newTopics) return

      setTopics(newTopics)
      const eventSource = new EventSource(url, {
        withCredentials: false,
      })
      setStreamEvent(eventSource)
      eventSource.onmessage = (evt) => {
        const data = JSON.parse(evt.data)
        setMercureData(data)
      }

      // eslint-disable-next-line consistent-return
      return () => {
        if (streamEvent) streamEvent.close()
      }
    }, [props.key, props.subscribeTopics])

    return <WrappedComponent mercureData={mercureData} {...props} />
  }
}
